"use strict";

const SVGOSM = require('./svgosm.js');

module.exports = function CSIENHANCE(doc) {
  //
  // Prevent it from running in a normal Node.js environment. (For when a bundle
  // is loaded for serverside rendering)
  //
  if (!doc || !doc.querySelectorAll) return;
  const svgosm = new SVGOSM('icon-svgosm-enhance');
  /**
   * Enhance the current node.
   *
   * @param {HTMLElement} node HTMLElement to enhance.
   * @private
   */

  function enhance(node) {
    const iconname = /uxicon-([\w|-]+)/gim.exec(node.className);
    if (!iconname) return;
    const name = iconname[1];
    const res = svgosm.get(name, function extract() {
      const details = svgosm.extract(node, `uxp-icon-${name}`);
      if (!details) return;
      return Object.assign(details, {
        title: node.title
      });
    });
    if (!res) return;
    const svg = doc.createElementNS(SVGOSM.xmlns, 'svg');
    const use = doc.createElementNS(SVGOSM.xmlns, 'use');
    [['role', 'img'], ['width', res.width], ['height', res.height], ['xmlns', SVGOSM.xmlns], ['class', 'uxicon-svg uxicon-svg-' + name]].forEach(data => svg.setAttribute(data[0], data[1]));
    use.setAttribute('fill', 'currentColor');
    use.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', res.link);
    node.classList.remove('uxicon-' + name, 'uxicon');
    node.classList.add('uxicon-enhanced');
    svg.appendChild(use);
    node.appendChild(svg);
  }
  /**
   * Track DOM changes so we can enhance newly inserted icons.
   *
   * @param {Event} evt DOM event.
   * @private
   */


  function uxIconInserted(evt) {
    if (evt.animationName !== 'uxIconInserted') return;
    enhance(evt.target);
  }

  [...doc.querySelectorAll('.uxicon:not(.uxicon-enhanced)')].forEach(enhance);
  doc.addEventListener('animationstart', uxIconInserted, false);
  return enhance;
}(typeof document !== 'undefined' && document);